var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-end"
  }, [_vm.clearanceApprovals.length ? _c('v-btn', {
    attrs: {
      "readonly": _vm.value.status !== _vm.RequestStatusEnum.DRAFT,
      "small": "",
      "color": "info",
      "elevation": 0
    },
    on: {
      "click": _vm.openCreateDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("clearance.requestApproval")) + " ")]) : _vm._e()], 1), _vm.isLoading ? _c('v-skeleton-loader', {
    staticClass: "pa-6",
    attrs: {
      "type": "list-item-two-line"
    }
  }) : !_vm.clearanceApprovals.length && !_vm.value.isCompleted ? _c('div', {
    staticClass: "mb-4",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mb-4",
    attrs: {
      "src": require("@/assets/undraw/undraw_no_data_re_kwbl.svg"),
      "height": "120",
      "width": "200",
      "contain": ""
    }
  }), _c('h3', {
    staticClass: "mb-2 grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("clearanceApproval.onboarding.title")) + " ")]), _c('p', {
    staticClass: "grey--text text--darken-1 mb-4",
    staticStyle: {
      "max-width": "400px",
      "margin": "0 auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("clearanceApproval.onboarding.description")) + " ")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('v-btn', {
    attrs: {
      "readonly": _vm.value.status !== _vm.RequestStatusEnum.DRAFT,
      "color": "primary",
      "large": "",
      "elevation": "0"
    },
    on: {
      "click": _vm.openCreateDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("clearanceApproval.createRequest")) + " ")], 1)], 1)], 1) : !_vm.clearanceApprovals.length && _vm.value.isCompleted ? _c('div', {
    staticClass: "mb-4",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mb-4",
    attrs: {
      "src": require("@/assets/undraw/undraw_mail_sent_re_0ofv.svg"),
      "height": "120",
      "width": "200",
      "contain": ""
    }
  }), _c('h3', {
    staticClass: "mb-2 grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("enums.ClearanceRequestStatusEnum.".concat(_vm.value.status))) + " ")])], 1) : _c('div', _vm._l(this.clearanceApprovals, function (clearanceApproval) {
    return _c('v-card', {
      key: 'refs-clearance-approval' + clearanceApproval.id,
      staticClass: "my-1",
      attrs: {
        "outlined": "",
        "flat": ""
      }
    }, [_c('refs-clearance-approval', {
      attrs: {
        "disabled": _vm.value.status,
        "item": clearanceApproval
      },
      on: {
        "click": function click($event) {
          return _vm.setSelectedClearanceApproval(clearanceApproval);
        }
      }
    })], 1);
  }), 1), _vm.selectedClearanceApproval ? _c('clearance-approval-side-card', {
    on: {
      "close": function close($event) {
        _vm.selectedClearanceApproval = null;
      }
    },
    model: {
      value: _vm.selectedClearanceApproval,
      callback: function callback($$v) {
        _vm.selectedClearanceApproval = $$v;
      },
      expression: "selectedClearanceApproval"
    }
  }) : _vm._e(), _c('clearance-approval-create-request-dialog', {
    ref: "createDialog",
    attrs: {
      "hideButton": true,
      "partnerId": _vm.value.partnerId,
      "report": _vm.report,
      "clearance": _vm.value
    },
    on: {
      "created": function created($event) {
        return _vm.clearanceApprovals.push($event);
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }